import { CampaignDetailPagePure } from '@poseidon/components/CampaignDetail/CampaignDetailPagePure';

import { api } from '@/utils/api';

type CampaignDetailViewProps = {
  contactId: string;
  campaignId: string;
  currentUserId: string;
  onBack: () => void;
};

export function CampaignDetailView({ contactId, campaignId, currentUserId, onBack }: CampaignDetailViewProps) {
  // Campaign list for header info
  const campaignsQuery = api.cadence.forContact.useQuery({ contactId }, { enabled: Boolean(contactId) });

  // Full cadence with steps
  const cadenceQuery = api.cadence.idOrNull.useQuery({ cadenceId: campaignId }, { enabled: Boolean(campaignId) });

  const historyQuery = api.history.contact.useQuery(
    { contactId, filter: { cadenceId: campaignId, invert: true }, pagination: { limit: 100, offset: 0 } },
    { enabled: Boolean(contactId) && Boolean(campaignId) },
  );

  const campaignHeader = campaignsQuery.data?.find((c) => c.id === campaignId);
  const cadenceData = cadenceQuery.data;

  return (
    <CampaignDetailPagePure
      currentUserId={currentUserId}
      campaignHeader={campaignHeader}
      steps={cadenceData?.cadence?.cadenceSteps ?? []}
      interruptMessage={cadenceData?.cadence?.cadence?.interruptMessage ?? null}
      interruptReason={cadenceData?.cadence?.cadence?.interruptReason ?? null}
      history={historyQuery.data?.data ?? []}
      isLoading={campaignsQuery.isPending || cadenceQuery.isPending}
      isHistoryLoading={historyQuery.isPending}
      onBack={onBack}
    />
  );
}
